import { render, staticRenderFns } from "./contractLayout.vue?vue&type=template&id=5b8d2323&scoped=true&"
import script from "./contractLayout.vue?vue&type=script&lang=js&"
export * from "./contractLayout.vue?vue&type=script&lang=js&"
import style0 from "./contractLayout.vue?vue&type=style&index=0&id=5b8d2323&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8d2323",
  null
  
)

export default component.exports